// Copyright 2022, Imprivata, Inc.  All rights reserved.

import type { ICameraFeedback, IDeviceData } from "../models";
import type { IFaceCaptureService } from "./IFaceCaptureService";
import { NoOpFaceCaptureService } from "./NoOpFaceCaptureService";
import { LibraryFaceCaptureService } from "./LibraryFaceCaptureService";
import { SimpleFaceCaptureService } from "./SimpleFaceCaptureService";

export async function getFaceCaptureService(
  setCapturedAction: (captured: boolean) => void,
  setCapturingAction: (capturing: boolean) => void,
  setDeviceDataAction: (deviceData: IDeviceData) => void,
  setFeedbackAction: (feedback: ICameraFeedback) => void,
  enableParavisionSdk = false,
  enableDebugLogging = false,
  preferredFacingMode?: 'user' | 'environment',
): Promise<IFaceCaptureService> {
  let service: IFaceCaptureService;

  console.log("[getFaceCaptureService] Creating face capture service");
  if ((window as Window & { playwright?: unknown }).playwright) {
    service = new NoOpFaceCaptureService(
      setCapturedAction,
      setCapturingAction,
      setDeviceDataAction,
      setFeedbackAction,
      preferredFacingMode,
    );
  } else if (enableParavisionSdk) {
    // Use the new library-based face capture service
    service = new LibraryFaceCaptureService(
      setCapturedAction,
      setCapturingAction,
      setDeviceDataAction,
      setFeedbackAction,
      enableDebugLogging,
      preferredFacingMode,
    );
  } else {
    service = new SimpleFaceCaptureService(
      setCapturedAction,
      setCapturingAction,
      setDeviceDataAction,
      setFeedbackAction,
      enableDebugLogging,
      preferredFacingMode,
    );
  }

  try {
    await service.initialize();
    return service;
  } catch (error) {
    console.error("Face capture service initialization failed:", error);
    throw error;
  }
}
